module.exports = __webpack_public_path__ + "img/ZonaMate_icone_Obiettivi.76317efa.svg";